export const app = {
  connectToYourWhatsappNumber: 'Lidhu me numrin tënd të WhatsApp',
  connectYourWhatsappBotWithYourWhatsappNumber: 'Lidh botin tënd të WhatsApp me numrin tënd të WhatsApp',
  connect: 'Lidhu',
};

